var map = {
	"./a-edit.svg": 119,
	"./accommodation.svg": 1502,
	"./air-tickets.svg": 4238,
	"./arrow-back.svg": 8791,
	"./arrow-down.svg": 6529,
	"./arrow-left.svg": 213,
	"./arrow-right.svg": 9494,
	"./bold.svg": 8855,
	"./booking-dialysis.svg": 6334,
	"./booking-status-declined.svg": 9343,
	"./booking-treatment.svg": 8891,
	"./bullet-list.svg": 6527,
	"./calendar-check.svg": 4586,
	"./calendar-clock.svg": 4512,
	"./calendar.svg": 5192,
	"./car.svg": 234,
	"./card-amex.svg": 5625,
	"./card-chip.svg": 3656,
	"./card-diners.svg": 8074,
	"./card-discover.svg": 7597,
	"./card-jcb.svg": 4069,
	"./card-mastercard.svg": 1690,
	"./card-unionpay.svg": 2146,
	"./card-unknown.svg": 3163,
	"./card-visa.svg": 9497,
	"./cash.svg": 1855,
	"./center-grid-idcard.svg": 9445,
	"./center-grid-notepad.svg": 8552,
	"./center-grid-patients.svg": 6912,
	"./center-grid-payment.svg": 4805,
	"./center-grid-reputation.svg": 1748,
	"./center-grid-stats.svg": 6378,
	"./certificate.svg": 8961,
	"./chat.svg": 1549,
	"./check-list.svg": 9922,
	"./checklist.svg": 64,
	"./chevron-down.svg": 2810,
	"./chevron-left-end-small.svg": 281,
	"./chevron-left-end.svg": 2186,
	"./chevron-left-white.svg": 6417,
	"./chevron-left.svg": 6030,
	"./chevron-right-end.svg": 5815,
	"./chevron-right-white.svg": 9728,
	"./chevron-right.svg": 229,
	"./chevron-small-down.svg": 581,
	"./chevron-small-left.svg": 2269,
	"./chevron-small-right.svg": 723,
	"./chevron-small-up.svg": 8690,
	"./chevron-up.svg": 9043,
	"./clear.svg": 2911,
	"./clinic-response.svg": 4795,
	"./clinic.svg": 7834,
	"./clock.svg": 7553,
	"./close-small.svg": 9691,
	"./close.svg": 8212,
	"./complete-transparency.svg": 8302,
	"./confirm.svg": 9525,
	"./country.svg": 4334,
	"./credit-card.svg": 7803,
	"./current-location.svg": 6528,
	"./diaverum-logo.svg": 6622,
	"./directions.svg": 4356,
	"./document.svg": 9526,
	"./double-tick.svg": 1500,
	"./downloads.svg": 1488,
	"./eat.svg": 1414,
	"./edit.svg": 9450,
	"./email-envelope.svg": 4078,
	"./email.svg": 5085,
	"./error.svg": 9644,
	"./euro.svg": 5074,
	"./exit.svg": 4589,
	"./filter.svg": 2622,
	"./heading.svg": 2327,
	"./help-gray.svg": 5244,
	"./help.svg": 7175,
	"./holiday.svg": 3242,
	"./id-profile.svg": 9324,
	"./info-tooltip.svg": 5734,
	"./info.svg": 3181,
	"./italic.svg": 9701,
	"./link.svg": 9523,
	"./list.svg": 3495,
	"./location-search.svg": 4094,
	"./location.svg": 903,
	"./medical.svg": 6709,
	"./menu.svg": 8685,
	"./minus.svg": 1541,
	"./more.svg": 6533,
	"./notepad.svg": 4772,
	"./online-reputation.svg": 6302,
	"./overview-booking-requests.svg": 6259,
	"./overview-bookings.svg": 3218,
	"./overview-clients.svg": 5410,
	"./overview-clinics.svg": 6185,
	"./overview-pending-clinics.svg": 9669,
	"./overview-reviews.svg": 448,
	"./parking.svg": 8680,
	"./patients.svg": 8736,
	"./payment.svg": 8512,
	"./person.svg": 9114,
	"./phone.svg": 7451,
	"./play.svg": 7388,
	"./plus.svg": 6876,
	"./price.svg": 3286,
	"./publictransport.svg": 6672,
	"./quote-marks.svg": 7274,
	"./rectangle-group-30.svg": 5134,
	"./refreshment.svg": 3680,
	"./repeat.svg": 2973,
	"./report.svg": 5007,
	"./safety.svg": 2119,
	"./search-module-check.svg": 1877,
	"./search-sufix.svg": 6487,
	"./search.svg": 314,
	"./settings.svg": 6873,
	"./share.svg": 2123,
	"./shield-check.svg": 3556,
	"./smilies.svg": 8618,
	"./smilies1.svg": 9762,
	"./smilies2.svg": 4138,
	"./smilies3.svg": 6704,
	"./social-facebook-share.svg": 3113,
	"./social-facebook.svg": 8458,
	"./social-instagram.svg": 2160,
	"./social-linkedIn-share.svg": 1053,
	"./social-linkedIn.svg": 5500,
	"./social-twitter-share.svg": 7907,
	"./social-twitter.svg": 3540,
	"./social-whatsapp-share.svg": 947,
	"./social-youtube.svg": 2596,
	"./sort.svg": 6301,
	"./standard-clinic.svg": 319,
	"./stats-stats.svg": 5021,
	"./stay.svg": 8785,
	"./success.svg": 4873,
	"./suitcase.svg": 199,
	"./taxi.svg": 7893,
	"./tick-success.svg": 4422,
	"./tick.svg": 7086,
	"./tickerdown.svg": 6322,
	"./tickerup.svg": 1259,
	"./ticket.svg": 6738,
	"./transfer.svg": 516,
	"./transportation.svg": 6714,
	"./trash.svg": 7042,
	"./treatment-time-icon.svg": 8130,
	"./treatment.svg": 806,
	"./tv.svg": 5960,
	"./underline.svg": 201,
	"./upload.svg": 6658,
	"./visit.svg": 7051,
	"./walk.svg": 3954,
	"./warning-2.svg": 7298,
	"./warning.svg": 6612,
	"./website-analytics.svg": 3235,
	"./wifi.svg": 965,
	"./window.svg": 7846,
	"./wire-transfer.svg": 7261
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9015;